import lookup from './lookup.store'
import department from './department.store'
import attachment from './attachment.store'
import province from './province.store'
import amphur from './amphur.store'
import tambon from './tambon.store'
import address from './address.store'
import fishingTool from './fishing-tool.store'
import report from './report.store'
import law from './law.store'
import lawProvision from './law-provision.store'
import faq from './faq.store'
import questionChoice from './question-choice.store'
import survey from './survey.store'
import surveyQuestion from './survey-question.store'

export default {
    lookup,
    department,
    attachment,
    province,
    amphur,
    tambon,
    address,
    fishingTool,
    report,
    faq,
    law,
    lawProvision,
    questionChoice,
    survey,
    surveyQuestion
}